import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { MatProgressBar } from '@angular/material/progress-bar'

import { ScheduleDriverService } from '../../../core/services/schedule/schedule-driver/schedule-driver.service'
import { MonitoringService } from '../../../core/services/monitoring/monitoring.service'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import { LinhaMonitoramentoVm } from '../../../core/models/monitoring-os.model'

// Só troca a pessoa. Chama Monitoramento/{osId}/atribuir (sprint 9/10, seção 06) —
// o back decide create/edit pelo agendaId enviado, sem a Torre montar a janela
// completa nem escolher o endpoint; se a OS estava em 12 (Aguardando Confirmação
// Operador), o back já confirma sozinho na mesma chamada.
@Component({
  selector: 'modal-alterar-motorista',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatProgressSpinner,
    MatProgressBar,
  ],
  templateUrl: './modal-alterar-motorista.component.html',
  styleUrl: './modal-alterar-motorista.component.scss',
})
export class ModalAlterarMotoristaComponent implements OnInit {
  @Output() response = new EventEmitter<boolean>()

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { item: LinhaMonitoramentoVm },
    private dialogRef: MatDialogRef<ModalAlterarMotoristaComponent>,
    private scheduleDriverService: ScheduleDriverService,
    private monitoringService: MonitoringService,
    private snackbar: SnackbarCustomService,
  ) {}

  motoristas: any[] = []
  loading = false
  salvandoId: number | null = null
  busca = ''

  ngOnInit(): void {
    this.carregar()
  }

  carregar(): void {
    this.loading = true
    this.scheduleDriverService
      .listPagedFreeDriver(1, 100, { ordemServicoId: this.data.item.codigoOs })
      .subscribe({
        next: (res: any) => {
          this.motoristas = Array.isArray(res.data) ? res.data : []
          this.loading = false
        },
        error: (err: any) => {
          this.loading = false
          this.snackbar.errorRequest(err)
        },
      })
  }

  get motoristasFiltrados(): any[] {
    const termo = this.busca.trim().toLowerCase()
    if (!termo) return this.motoristas
    return this.motoristas.filter(
      (m) =>
        (m.nomeFuncionario ?? '').toLowerCase().includes(termo) ||
        (m.numeroRegistro ?? '').toLowerCase().includes(termo),
    )
  }

  selecionar(motorista: any): void {
    this.salvandoId = motorista.id
    const item = this.data.item

    this.monitoringService.atribuir(item.codigoOs, {
      motoristaId: motorista.id,
      agendaMotoristaId: item.motorista?.agendaId ?? null,
    }).subscribe({
      next: (res: any) => {
        this.salvandoId = null
        this.snackbar.success(res.message ?? 'Motorista alterado com sucesso.')
        this.response.emit(true)
        this.dialogRef.close()
      },
      error: (err: any) => {
        this.salvandoId = null
        this.snackbar.errorRequest(err)
      },
    })
  }

  close(): void {
    this.dialogRef.close()
  }
}
